module.exports = __webpack_public_path__ + "img/poster-3.de161eb7.jpg";